$('.houdiniForm').submit(function(event) {
    //console.log(RECAPTCHA_SITE_KEY);
    event.preventDefault();
    var form = $(this);

    form.validate();
    var isFormValid =form.valid();

    if (isFormValid) {
        event.preventDefault();
        if(RECAPTCHA_SITE_KEY){
            grecaptcha.ready(function() {
                grecaptcha.execute(RECAPTCHA_SITE_KEY, {action: 'formsubmit'}).then(function(token) {
                    form.prepend('<input type="hidden" name="token" value="' + token + '">');
                    form.prepend('<input type="hidden" name="action" value="formsubmit">');
                    form.unbind('submit').submit();
                });;
            });
        } else {
            form.unbind('submit').submit();
        }
    }
  });
$('.ticketing form.basic').submit(function(event) {
    //console.log(RECAPTCHA_SITE_KEY);
    event.preventDefault();
    var form = $(this);

    form.validate();

    var isFormValid = form.valid();

    if (isFormValid) {
        form.unbind('submit').submit();
    }
});
